<script>
import CkeditorWidget from "@/components/widgets/editor.vue";

export default {
  components: {
    CkeditorWidget,
  },
  props: {
    soalStats: Object,
    currentQuestion: Object,
    nextSoal: Function,
    index_soal: Number,
    idJadwal: String,
    idJadwalPeserta: String,
  },
  data() {
    return {
      BACKEND_URL: process.env.VUE_APP_BACKEND_URL,
      contentPreview: "",
    };
  },
};
</script>

<template>
  <div class="mym-question-body">
    <div class="mym-question-cardbox">
      <!-- TOMBOL MULAI -->
      <div class="pt-3 mb-3">
        <div class="text-center fw-bold">
          <button
            type="button"
            class="mym-btn mym-bg-success w-100"
            @click="nextSoal(0)"
          >
            <i class="fas fa-play me-1"></i>
            MULAI MENGERJAKAN
          </button>
        </div>
      </div>

      <!-- LABEL INSTRUKSI -->
      <div class="mym-qn-header">
        <div class="mym-question-number">
          <strong>Instruksi</strong>
        </div>
      </div>

      <div class="mym-question-section">
        <h4>Petunjuk Essai</h4>
        <p>Silahkan tulis jawaban Anda pada kolom jawaban yang tersedia di bawah.</p>
        <p>
          Klik <strong>"Simpan Jawaban"</strong> untuk menyimpan jawaban Anda
          sebelum berpindah ke soal berikutnya.
        </p>
        <p>Klik "History Jawaban" untuk melihat riwayat jawaban yang pernah disimpan.</p>

        <!-- CONTOH SOAL -->
        <div class="mb-3">
          <b>Contoh Soal</b>

          <!-- Studi Kasus -->
          <div
            class="mym-card-case mt-2 mb-3"
            v-if="currentQuestion?.soal_text"
          >
            <div class="mym-card-jumbotron-header">
              <div class="mym-card-jumbotron-icon text-light">
                <i class="fa fa-file-alt"></i>
              </div>
              <h3 class="mym-card-jumbotron-title">Studi Kasus</h3>
            </div>
            <div class="mym-card-jumbotron-content">
              {{ currentQuestion?.soal_text }}
            </div>
          </div>

          <!-- Gambar soal -->
          <img
            v-if="currentQuestion?.soal_image"
            :src="BACKEND_URL + currentQuestion?.soal_image"
            class="mym-question-image mb-3"
          />

          <!-- Pertanyaan -->
          <div class="mym-question-navigation mb-3">
            <div class="mym-question-section">
              <div class="mym-question-text">
                <b>Contoh Soal</b>
                <div v-html="currentQuestion?.pertanyaan"></div>
              </div>
            </div>
          </div>

          <!-- Jawaban Preview Full Width -->
          <div class="card w-100">
            <div class="card-header bg-primary text-white">
              <h6 class="mb-0 text-white">Jawaban</h6>
            </div>
            <div class="card-body">
              <CkeditorWidget v-model="contentPreview" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
